export default theme => ({
  root: {
    backgroundColor: theme.palette.background.mainLight,
    // backgroundColor: 'pink',
    display: "inline-table",
    flexDirection: "column",
    minHeight: "100%",
    paddingTop: "79px" // 80 px navbar size - 1px top border
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "63px",
    flexShrink: 0
  },
  logoLink: {
    fontSize: 0,
    textDecoration: "none"
  },
  logoImage: {
    cursor: "pointer",
    width: "40px"
  },
  navLink: {
    textDecoration: "none"
  },
  listItem: {
    borderTop: `1px solid ${theme.palette.background.mainLight}`,
    cursor: "pointer",
    backgroundColor: theme.palette.background.main,
    "&:hover": {
      backgroundColor: theme.palette.background.mainDark,
      "& $listItemIcon": {
        color: theme.palette.secondary.main
      },
      "& $listItemText": {
        color: theme.palette.secondary.light
      }
    },
    "& + &": {
      marginTop: theme.spacing(1)
    }
  },
  activeListItem: {
    backgroundColor: theme.palette.background.mainDark,
    borderTop: `1px solid ${theme.palette.background.mainLight}`,
    cursor: "pointer",
    "& $listItemText": {
      color: theme.palette.secondary.light
    },
    "& $listItemIcon": {
      color: theme.palette.secondary.main
    }
  },

  //  submenu CSS

  submenuDividerContainer: {
    backgroundColor: theme.palette.background.mainDark
  },
  submenuDivider: {
    display: "block",
    marginLeft: "24px",
    marginRight: "24px",
    backgroundColor: theme.palette.background.mainLight
  },
  submenuListItem: {
    cursor: "pointer",
    backgroundColor: theme.palette.background.mainDark,
    paddingLeft: "48px",
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    "&:hover": {
      backgroundColor: theme.palette.background.mainDark,
      "& $submenuListItemText": {
        color: theme.palette.primary.main
      }
    },
    "& + &": {
      marginTop: theme.spacing(1)
    }
  },
  submenuActiveListItem: {
    backgroundColor: theme.palette.background.mainDark,
    paddingLeft: "48px",
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    "& $submenuListItemText": {
      color: theme.palette.primary.main
    }
  },
  submenuListItemText: {
    fontWeight: 500,
    fontSize: "12px",
    color: theme.palette.text.darkBackground,
    textTransform: "uppercase",
    letterSpacing: "0.39px"
  },

  listItemIcon: {
    marginRight: 0,
    color: theme.palette.text.darkBackground
  },
  listItemText: {
    fontWeight: 500,
    color: theme.palette.text.darkBackground,
    textTransform: "uppercase",
    letterSpacing: "0.45px"
  },
  listDivider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.dividerDark
  }
});
